/**
 * Composable for opening a dialog to select a model for an AI queue item
 * Uses Quasar Dialog plugin with a custom component
 * @module useModelSelectorDialog
 * @version 1.0.0
 */
import { Dialog } from 'quasar'
import ModelSelectorDialog from '../components/ModelSelectorDialog.vue'
import type { AiQueueItem } from '../types'

/**
 * Opens a dialog for model selection for the given queue item
 * @param queueItem - The AI queue item to select a model for
 * @returns Promise<{ queueId: string, modelType: string }>
 */
export function openModelSelectorDialog(queueItem: AiQueueItem): Promise<{ queueId: string; modelType: string }> {
  return new Promise((resolve) => {
    Dialog.create({
      component: ModelSelectorDialog,
      componentProps: { queueItem },
      persistent: true,
      onOk: (result: { queueId: string; modelType: string }) => {
        resolve(result)
      },
      onDismiss: () => {
        // Optionally handle cancel
      },
    })
  })
}
